export default `<svg width="12px" height="17px" viewBox="0 0 12 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="arrow" fill="#1F303C">
            <polygon id="Page-1" points="2.707 2.0006 2 2.7066 8.01 8.7176 2 14.7276 2.707 15.4346 9.424 8.7176"></polygon>
        </g>
    </g>
</svg>`;
